import { Mesh, Plane, Vector3 } from 'three';
import { Nodes, RenderComponentOptions, Vector } from '../types/model.types';

export abstract class RenderComponentStrategy<T = unknown> {
	abstract componentKey: string;

	constructor(public options: RenderComponentOptions<T>) {}

	public render(nodes: Nodes) {
		const geometry = this.getGeometry(nodes);
		const { color, position, rotation, scale } = this.options;

		const clippingPlane = new Plane(new Vector3(0, 0, -1), 1);

		return (
			<mesh geometry={geometry} rotation={rotation} position={position} scale={scale}>
				<meshStandardMaterial color={color} clippingPlanes={[clippingPlane]} clipShadows />
			</mesh>
		);
	}

	public setPosition(position: Vector) {
		this.options.position = position;
	}

	protected getGeometry(nodes: Nodes) {
		const node = nodes[this.componentKey];

		if (node instanceof Mesh) {
			return node.geometry;
		}

		throw new Error(`Geometry not found for component: ${this.componentKey}`);
	}
}
